import RFIDTable from './RFIDTable.vue';
export default RFIDTable;
